export enum AccountStatus {
  UNSET_ACCOUNT_STATUS = 'UNSET_ACCOUNT_STATUS', // Do not use, needed because of proto3 limitations
  ACCOUNT_PENDING = 'ACCOUNT_PENDING',
  ACCOUNT_ACTIVATED = 'ACCOUNT_ACTIVATED',
  ACCOUNT_DEACTIVATED = 'ACCOUNT_DEACTIVATED',
  ACCOUNT_PENDING_DEACTIVATED = 'ACCOUNT_PENDING_DEACTIVATED',
}
